import { Card, CardBody, Col } from "reactstrap";
import CommonCardFooter from "../Common/CommonCardFooter";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { InlineStyles } from "../../../../Constant";
import { INLINE_STYLE } from "../../../../Data/FormControl/MegaOptions";
import InlineStyleForm from "./InlineStyleForm";

const InlineStyle = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={InlineStyles} span={INLINE_STYLE} />
        <CardBody className="megaoptions-border-space-sm">
          <InlineStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="warning" color2="light-warning" btn2Class='list-light-warning' />
      </Card>
    </Col>
  )
};

export default InlineStyle;
